import { IncomingCallModal } from "@/features/incomingCall/IncomingCallModal";
import { useIncomingCallNotice } from "@/features/incomingCall/useIncomingCallNotice";

/** Hört auf eingehende Teams-Anrufe und öffnet den Kontakt im schon offenen Fenster. */
export function IncomingCallHost() {
  const { call, dismiss } = useIncomingCallNotice();
  return <IncomingCallModal call={call} onDismiss={dismiss} />;
}
